module.exports = __webpack_public_path__ + "img/custom-3.217cc09.png";